import { useNavigate } from 'react-router-dom';

export default function ContactUs() {
  const navigate = useNavigate();

  return (
    <div className='privacy-policy-page'>
      <nav className="container shadow-none py-0">
        <div className="navbar navbar-expand-lg landing-navbar border-top-0">
          <div className="navbar-brand app-brand demo d-flex py-0 py-lg-2 me-6">
            <a className="app-brand-link">
              <img src="/assets/img/logo-2.png" alt="" style={{ width: '60px' }} />
              <span className="app-brand-text demo fw-semibold ms-2 ps-1" style={{ color: '#efbb30' }}>
                THIEN LONG GROUP
              </span>
            </a>
          </div>

          <div className="landing-menu-overlay d-lg-none"></div>
          <ul className="navbar-nav flex-row align-items-center ms-auto">
            <li>
              <a
                className="btn btn-text-warning px-2 px-sm-4 px-lg-2 px-xl-4"
                onClick={() => {
                  navigate('/login');
                }}
              >
                <span className="tf-icons ri-user-line me-md-1"></span>
                <span className="d-none d-md-block">Đăng nhập</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <section className="section-py privacy-policy" >
        <div className="container">
          <div className="row">
            <div className="col-lg-9 mx-auto">
              <h1>Thông Tin Liên Hệ</h1>
              <ul className="contact-info">
                <li><label>Địa chỉ:</label> TT1 Cao Thắng, Móng Cái, Quảng Ninh</li>
                <li><label>Số điện thoại:</label> (+84) 0210-320-466</li>
                <li><label>Email:</label> contact@vanchuyenthienlong.com</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <footer className="landing-footer" style={{position: 'fixed',
        bottom: '0',
        width: '100%'}}>
        <div className="footer-top position-relative overflow-hidden">
          <img src="/assets/img/landing-page/footer-bg.png" alt="footer bg" className="footer-bg banner-bg-img" />
          <div className="container position-relative">
            <div className="row gx-0 gy-7 gx-sm-6 gx-lg-12">
              <div className="col-lg-9">
                <a className="app-brand-link mb-6">
                  <img src="/assets/img/logo-2.png" alt="logo" style={{ width: '60px' }} />
                  <span className="app-brand-text demo footer-link fw-semibold ms-1" style={{ color: '#efbb30' }}>
                    THIEN LONG GROUP
                  </span>
                </a>
                <p className="footer-text footer-logo-description mb-6">Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ với chúng tôi qua địa chỉ email: contact@vanchuyenthienlong.com.</p>
              </div>
              <div className="col-lg-3 col-md-4">
                <h6 className="footer-title mb-4 mb-lg-6">Tải xuống ứng dụng của chúng tôi</h6>
                <a className="d-block footer-link mb-4">
                  <img src="/assets/img/landing-page/apple-icon.png" alt="apple icon" />
                </a>
                <a className="d-block footer-link">
                  <img src="/assets/img/landing-page/google-play-icon.png" alt="google play icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
